var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex justify-center flex-wrap",attrs:{"fluid":""}},_vm._l((_vm.children),function(child){return _c('header-card',{key:child.name,class:_vm.setOldGuiCssClass(child),attrs:{"node":child}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }